module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAAyCAYAAAAJHRh4AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAD/SURBVHgB7dnRDYJAEATQxVgAHUgHUoIdaAfSgbEDSrAD6EDsADvQCrQEOjiH+KXhkvNDwhzzks2Zy304ibcuwUxk0hLnXIr1jMpRqcWjRh37gBU+FBantg/oLF5d7AFtYZFbevZvqItx2dq7UX5ywyojg+9cDwWJ/ieqgOwUkJ0CslNAdr5RLcMQUBiX1dCmnibYKSC72XbRK6o0LgfU7nvTF/CRJElrRHx/a7qD7BSQnQKyU0B2sx3VRoUpZINlH3j8jinrFHh2GgEhs/CXsC0qOKDuIDs1mZF0qOcPZ4NNIiC6YoOlsT/QHWSngOx8TSbH+FQal/XQpt5NsHsBLOZljaXkxScAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/billing-icon.png
// module id = 851
// module chunks = 1